(function () {
  function init(root) {
    if (root.dataset.iwReady) return;
    root.dataset.iwReady = 'true';
    var track = root.querySelector('.iw-track');
    var fallback = root.querySelector('[data-iw-fallback]');
    if (!track) return;
    var limit = Math.min(30, Math.max(1, Number(root.dataset.iwLimit) || 12));
    var tries = 0;
    var loaded = false;
    var pending = false;
    var observer;
    function load() {
      if (pending || loaded || !root.isConnected) return;
      pending = true;
      tries++;
      var controller = new AbortController();
      var timeout = setTimeout(function () { controller.abort(); }, 10000);
      fetch('https://signage.views.fr/api/embed/instagram?limit=' + limit, { signal: controller.signal })
        .then(function (response) {
          if (!response.ok) throw new Error('Unavailable');
          return response.json();
        })
        .then(function (data) {
          if (!root.isConnected) return;
          var posts = Array.isArray(data.posts) ? data.posts.filter(function (post) { return post.image || post.video; }).slice(0, limit) : [];
          if (!posts.length) throw new Error('Empty');
          var fragment = document.createDocumentFragment();
          var videos = [];
          posts.forEach(function (post) {
            var card = document.createElement('a');
            card.className = 'iw-card';
            card.href = post.permalink || 'https://instagram.com/viewsfrance';
            card.target = '_blank';
            card.rel = 'noopener';
            card.setAttribute('aria-label', post.caption ? post.caption.slice(0, 140) : 'Voir la publication de @viewsfrance sur Instagram');
            var video = post.type === 'video' && post.video;
            var media = document.createElement(video ? 'video' : 'img');
            if (video) {
              media.className = 'iw-video';
              media.muted = true;
              media.loop = true;
              media.playsInline = true;
              media.preload = 'none';
              media.poster = post.image || '';
              media.src = post.video;
              videos.push(media);
            } else {
              media.src = post.image;
              media.alt = '';
              media.loading = 'lazy';
              media.width = 800;
              media.height = 1000;
            }
            card.appendChild(media);
            fragment.appendChild(card);
          });
          track.replaceChildren(fragment);
          loaded = true;
          if (fallback) fallback.hidden = true;
          if (videos.length && 'IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            observer = new IntersectionObserver(function (entries) {
              entries.forEach(function (entry) {
                if (entry.isIntersecting && !document.hidden) entry.target.play().catch(function () {});
                else entry.target.pause();
              });
            }, { threshold: 0.4 });
            videos.forEach(function (video) { observer.observe(video); });
          }
        })
        .catch(function () {
          if (!root.isConnected) return;
          if (tries < 2) setTimeout(load, 1500);
          else if (fallback && !track.children.length) fallback.hidden = false;
        })
        .finally(function () { clearTimeout(timeout); pending = false; });
    }
    load();
    function retryOnline() { if (!loaded && tries < 3) load(); }
    window.addEventListener('online', retryOnline);
    document.addEventListener('shopify:section:unload', function unload(event) {
      if (!event.target.contains(root)) return;
      if (observer) observer.disconnect();
      window.removeEventListener('online', retryOnline);
      document.removeEventListener('shopify:section:unload', unload);
    });
  }
  function scan(scope) { scope.querySelectorAll('[data-iw-auto]').forEach(init); }
  scan(document);
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
})();
